import React, { FC } from "react";
import { IScheduleCalendarMeeting } from "../../../utils";
import { getDateTitle } from "../../../components/meeting/utils";
import '../../../styles/components/calendar/schedule/meeting.scss';

interface MeetingProps {
  meeting: IScheduleCalendarMeeting;
  onOpenMeeting: (id: number, calendarId: number, start?: Date, end?: Date) => void;
}

export const Meeting: FC<MeetingProps> = ({ meeting, onOpenMeeting }) => {
  const onClickMeeting = () => onOpenMeeting(meeting.id, meeting.calendarId, meeting.startTime, meeting.endTime);
  return (
    <div 
      className="meeting-schedule" 
      style={{ backgroundColor: meeting.color }}
      onClick={onClickMeeting}
    >
      <p className="meeting-schedule-name">{meeting.name}</p>
      <span className="meeting-schedule-time">{getDateTitle(meeting.startTime)} - {getDateTitle(meeting.endTime)}</span>
    </div>
  )
}
